import { GET_SERVICECITY } from "resources/actionTypes";

const initialStateCity = {
  userServiceCity: [],
  loading: false,
  error: null,
};

export function userCity(state = initialStateCity, action){
  switch(action.type){
    case GET_SERVICECITY.GET_SERVICECITY_REQUESTED:
      return{
        ...state,
        loading:true
      };
    case GET_SERVICECITY.GET_SERVICECITY_SUCCESS:
      return{
        ...state,
        loading: false,
        userServiceCity: action.userServiceCity
      };
    case GET_SERVICECITY.GET_SERVICECITY_FAILED:
      return{
        ...state,
        loading:false,
        error: action.message
      };
      default:
        return state;
  }
}
